<template>
  <div class="content">
    <div class="main">
      <p class="title">跳转失败</p>
      <div class="titleText">
        <span style="color:#409eff;margin-top:10px"></span>
      </div>
      <!-- <el-form v-model="user" class="formStyle">
        <el-form-item v-show="select_userName">
          <el-select
            v-model="user.userName"
            placeholder="请选择用户"
            @change="select_change"
            style="float:left;margin-left:30px;width:70%"
          >
            <el-option v-for="item in user.userList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="select_password">
          <el-input id="password" type="password" v-model="user.passWord" placeholder="请输入CA密码"></el-input>
        </el-form-item>
      </el-form> -->
      <!-- <div>
        <el-button
          style="margin-top:10px;width:180px;font-size:18px;height:45px"
          type="primary"
          round
          @click="login_auto"
        >再次点击身份校验</el-button>
      </div>
      <a
        @click="register"
        style="margin-top:20px;display:inline-block;font-size:24px;"
      >账号校验失败，请点击此处前往苏州市施工图审查系统进行注册</a> -->
    </div>
  </div>
</template>

<script>

export default {
  
  data() {
    return {
      url: {
        autoLogin:'/draw/auto/checkToken'
      },
    };
  },
  created(){
    this.login_auto();
  },
  mounted() {
  },
  methods: {
    login_auto() {
      this.$http
        .post(
          this.url.autoLogin + "?token=" + this.$route.query.access_token
        )
        .then(res => {
          if(res.data.status == 200 && res.data.result !=={}){
              this.$message.success("登录成功，欢迎回来");
              this.$router.push({
              name: `supersive_login-dd`,
              query: {
                Type: "supervise",
                username: res.data.result.username,
                // password:"suzhou123"
              }
          });
          } else {
            this.$message({
              message: '跳转失败',
              type: 'error',
              center: true
        });
            this.$router.push("/"); 
          }
        });
    },
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/login/ddloginskips.vue